import login from "./entities/login-slice";
import health from "./entities/health-slice";
import bet from "./entities/bet-slice";
import cashout from "./entities/cashout-slice";
import updatePlayerAvatar from "./entities/update-player-avatar-slice";
import playerSettings from "./entities/player-settings-slice";
import gameDifficulty from "./entities/game-difficulty-slice";
import betAmount from "./entities/game-controls/bet-amount-slice";
import popupMessage from "./entities/popup-message-slice";
import spinner from "./entities/spinner-slice";
import plinkoActive from "./entities/plinko-active-slice";
import hotKeys from "./entities/game-controls/hot-keys-slice";
import soundsLoaded from "./entities/sounds-loaded-slice";
import ticketTimer from "./entities/ticket-timer-slice";
import jackpot from "./entities/jackpot-slice";
import jackpotModal from "./entities/modals/jackpot-modal-slice";
import balance from "./entities/balance-slice";
import cancel from "./entities/cancel-slice";
import musicVolume from "./entities/game-controls/music-volume-slice";
import autoPlay from "./entities/auto-play-slice";
import numberOfBets from "./entities/number-of-bets-slice";
import autoPlayTabActive from "./entities/auto-play-tab-active-slice";
import { combineReducers } from "redux";
import autoBet from "./entities/auto-bet-slice";
import remainingNumberOfBets from "./entities/remaining-no-of-bets-slice";
import bounsRoundsModal from "./entities/modals/bonus-rounds-modal-slice";
import bonusLabel from "./entities/bonus-label-slice";
import freeBet from "./entities/free-bet-slice";
import freeTicketInfo from "./entities/freetickets/free-ticket-info-slice";
import freeBetsState from "./entities/free-bets-state-slice";
import webSocketStatus from "./entities/web-sock-status-slice";
import cumulativeBonusLabel from "./entities/cumulative-bonus-label-slice";
import bonusCumulative from "./entities/freetickets/bonus-cumulative-slice";
import cumulativeWonModal from "./entities/modals/cumulative-won-modal-slice";
import activeTab from "./entities/focused-tab-slice";
import betHistory from "./entities/bet-history-slice";
import jackpotHistory from "./entities/jackpot-history-slice";
import playerBonusHistory from "./entities/player-bonus-history-slice";
import numberOfRows from "./entities/number-of-rows-slice";
import turboMode from "./entities/turbo-mode-slice";
import hitOdds from "./entities/hit-odds-slice";
import serverMessages from "./entities/server-messages-slice";
import pendingBetsReducer from "./entities/pending-bets-slice";
import turboModeModal from "./entities/modals/turbo-mode-modal-slice";
import plinkoInflightBallsReducer from "./entities/plinko-inflight-balls-slice";
import gameControlsTabIndex from "./entities/game-controls-tab-index-slice";

export default combineReducers({
  login,
  health,
  bet,
  cashout,
  updatePlayerAvatar,
  playerSettings,
  gameDifficulty,
  betAmount,
  popupMessage,
  spinner,
  plinkoActive,
  hotKeys,
  soundsLoaded,
  ticketTimer,
  jackpot,
  balance,
  jackpotModal,
  cancel,
  musicVolume,
  autoPlay,
  numberOfBets,
  autoPlayTabActive,
  webSocketStatus,
  remainingNumberOfBets,
  autoBet,
  bounsRoundsModal,
  bonusLabel,
  freeBet,
  freeBetsState,
  freeTicketInfo,
  cumulativeBonusLabel,
  bonusCumulative,
  cumulativeWonModal,
  activeTab,
  betHistory,
  jackpotHistory,
  playerBonusHistory,
  numberOfRows,
  turboMode,
  hitOdds,
  serverMessages,
  pendingBets: pendingBetsReducer,
  turboModeModal,
  plinkoInflightBalls: plinkoInflightBallsReducer,
  gameControlsTabIndex
});
